export default "/images/debit24x24.svg?0b0979c6ca60f3a5bd0afc33ef121311";